export default __webpack_public_path__ + "static/media/checkbox.370bbf53.svg";